import * as Sebrae from '@sebrae/react-core';
import React from 'react';
import {
  ENDPOINT_CANDIDATES,
  ENDPOINT_FORM_QUESTIONS_DATA,
  PROFESSIONAL_SITUATION,
} from './constants';

export function useCandidateService() {
  const { fetchData, loading, data } =
    Sebrae.usePagination(ENDPOINT_CANDIDATES);

  const { backendGet } = Sebrae.useBackend();

  const findCandidateByCpf = React.useCallback(
    (cpf = '') => backendGet(`${ENDPOINT_CANDIDATES}/cpf/${cpf}`),
    [backendGet],
  );

  const professionalSituationService = React.useCallback(
    (module = '') => backendGet(`${PROFESSIONAL_SITUATION}/${module}`),
    [backendGet],
  );

  const formQuestionsData = React.useCallback(
    (moduleId) => backendGet(`${ENDPOINT_FORM_QUESTIONS_DATA}/${moduleId}`),
    [backendGet],
  );

  return {
    professionalSituationService,
    findCandidateByCpf,
    fetchData,
    formQuestionsData,
    data,
    loading,
  };
}
